import styled from 'styled-components'

export const FormTitle = styled.h2`
  margin-bottom: 2rem;
`
export const Form = styled.form`
  max-width: 560px;
`

export const AddressBlock = styled.div`
  padding-top: 2rem;
`

export const BottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 50px;

  button {
    margin-left: 30px;
  }
`
